export const SET_ID_DETAILS_REFUND = "SET_ID_DETAILS_REFUND"
export const CLEAR_DETAILS_REFUND_ID = "CLEAR_DETAILS_REFUND_ID"
